// Job Card Listing
export const GET_JOB_CARD_LISTING_REQUEST = 'GET_JOB_CARD_LISTING_REQUEST';
export const GET_JOB_CARD_LISTING_SUCCESS = 'GET_JOB_CARD_LISTING_SUCCESS';
export const GET_JOB_CARD_LISTING_FAIL = 'GET_JOB_CARD_LISTING_FAIL';

// Job Card By Id
export const GET_JOBCARD_BY_ID_REQUEST = 'GET_JOBCARD_BY_ID_REQUEST';
export const GET_JOBCARD_BY_ID_SUCCESS = 'GET_JOBCARD_BY_ID_SUCCESS';
export const GET_JOBCARD_BY_ID_FAIL = 'GET_JOBCARD_BY_ID_FAIL';
export const CLEAR_GET_JOBCARD_BY_ID_STATE = 'CLEAR_GET_JOBCARD_BY_ID_STATE';

// Delete Job Card
export const DELETE_JOB_CARD_REQUEST = 'DELETE_JOB_CARD_REQUEST';
export const DELETE_JOB_CARD_SUCCESS = 'DELETE_JOB_CARD_SUCCESS';
export const DELETE_JOB_CARD_FAIL = 'DELETE_JOB_CARD_FAIL';

// Add Job Card
export const ADD_JOB_CARD_REQUEST = 'ADD_JOB_CARD_REQUEST';
export const ADD_JOB_CARD_SUCCESS = 'ADD_JOB_CARD_SUCCESS';
export const ADD_JOB_CARD_FAIL = 'ADD_JOB_CARD_FAIL';

// Get Job Card Bay List
export const GET_JOB_CARD_BAY_LISTING_REQUEST =
  'GET_JOB_CARD_BAY_LISTING_REQUEST';
export const GET_JOB_CARD_BAY_LISTING_SUCCESS =
  'GET_JOB_CARD_BAY_LISTING_SUCCESS';
export const GET_JOB_CARD_BAY_LISTING_FAIL = 'GET_JOB_CARD_BAY_LISTING_FAIL';

// Update Job Card
export const UPDATE_JOB_CARD_REQUEST = 'UPDATE_JOB_CARD_REQUEST';
export const UPDATE_JOB_CARD_SUCCESS = 'UPDATE_JOB_CARD_SUCCESS';
export const UPDATE_JOB_CARD_FAIL = 'UPDATE_JOB_CARD_FAIL';

// Confirm Items Status
export const CONFIRM_ITEM_STATUS_REQUEST = 'CONFIRM_ITEM_STATUS_REQUEST';
export const CONFIRM_ITEM_STATUS_SUCCESS = 'CONFIRM_ITEM_STATUS_SUCCESS';
export const CONFIRM_ITEM_STATUS_FAIL = 'CONFIRM_ITEM_STATUS_FAIL';

// all jobcard comments
export const GET_ALL_COMMENTS_REQUEST = 'GET_ALL_COMMENTS_REQUEST';
export const GET_ALL_COMMENTS_SUCCESS = 'GET_ALL_COMMENTS_SUCCESS';
export const GET_ALL_COMMENTS_FAIL = 'GET_ALL_COMMENTS_FAIL';

// adding comment on jobcard
export const CREATE_COMMENT_REQUEST = 'CREATE_COMMENT_REQUEST';
export const CREATE_COMMENT_SUCCESS = 'CREATE_COMMENT_SUCCESS';
export const CREATE_COMMENT_FAIL = 'CREATE_COMMENT_FAIL';

// update comment
export const UPDATE_COMMENT_REQUEST = 'UPDATE_COMMENT_REQUEST';
export const UPDATE_COMMENT_SUCCESS = 'UPDATE_COMMENT_SUCCESS';
export const UPDATE_COMMENT_FAIL = 'UPDATE_COMMENT_FAIL';

// delete comment
export const DELETE_COMMENT_REQUEST = 'DELETE_COMMENT_REQUEST';
export const DELETE_COMMENT_SUCCESS = 'DELETE_COMMENT_SUCCESS';
export const DELETE_COMMENT_FAIL = 'DELETE_COMMENT_FAIL';

// update comment reply
export const UPDATE_COMMENT_REPLY_REQUEST = 'UPDATE_COMMENT_REPLY_REQUEST';
export const UPDATE_COMMENT_REPLY_SUCCESS = 'UPDATE_COMMENT_REPLY_SUCCESS';
export const UPDATE_COMMENT_REPLY_FAIL = 'UPDATE_COMMENT_REPLY_FAIL';

// delete comment reply
export const DELETE_COMMENT_REPLY_REQUEST = 'DELETE_COMMENT_REPLY_REQUEST';
export const DELETE_COMMENT_REPLY_SUCCESS = 'DELETE_COMMENT_REPLY_SUCCESS';
export const DELETE_COMMENT_REPLY_FAIL = 'DELETE_COMMENT_REPLY_FAIL';

// adding comment on jobcard
export const REPLY_TO_COMMENT_REQUEST = 'REPLY_TO_COMMENT_REQUEST';
export const REPLY_TO_COMMENT_SUCCESS = 'REPLY_TO_COMMENT_SUCCESS';
export const REPLY_TO_COMMENT_FAIL = 'REPLY_TO_COMMENT_FAIL';

// Get jobcard Logs
export const GET_JOBCARD_LOGS_REQUEST = 'GET_JOBCARD_LOGS_REQUEST';
export const GET_JOBCARD_LOGS_SUCCESS = 'GET_JOBCARD_LOGS_SUCCESS';
export const GET_JOBCARD_LOGS_FAIL = 'GET_JOBCARD_LOGS_FAIL';

// GETT ALL MESSAGE
export const GET_ALL_MESSAGES_REQUEST = 'GET_ALL_MESSAGES_REQUEST';
export const GET_ALL_MESSAGES_SUCCESS = 'GET_ALL_MESSAGES_SUCCESS';
export const GET_ALL_MESSAGES_FAIL = 'GET_ALL_MESSAGES_FAIL';

// SEND MESSAGE
export const SEND_MESSAGE_REQUEST = 'SEND_MESSAGE_REQUEST';
export const SEND_MESSAGE_SUCCESS = 'SEND_MESSAGE_SUCCESS';
export const SEND_MESSAGE_FAIL = 'SEND_MESSAGE_FAIL';

// CLEARING NEW MESSAGE STATES
export const CLEAR_NEW_MESSAGE_STATE = 'CLEAR_NEW_MESSAGE_STATE';

// CLEARING NEW reply STATES
export const CLEAR_NEW_REPLY_STATE = 'CLEAR_NEW_REPLY_STATE';

// Clear Jobcard Logs State
export const CLEAR_GET_JOBCARD_LOGS_STATE = 'CLEAR_GET_JOBCARD_LOGS_STATE';

export const CLEAR_JOBCARD_STATES = 'CLEAR_JOBCARD_STATES';

export const SET_SELECTED_JOBCARD_DATA = 'SET_SELECTED_JOBCARD_DATA';
